import { useEffect, useState } from 'react';
import { getPageAdmin } from '../../services/page-admin.service';
import { PageAdminDto } from '../../services/dtos/page-admin.dto';
import PageAdminUi from '../../components/userInterfaces/page-admin-ui';
import { Skeleton } from '@mui/material';
import { useSnackbars } from '../../hooks/snackbar.hook';
import { showAxiosMessageError } from '../../utils/error-message.util';

/**
 * Page admin
 * @constructor
 */
export default function PageAdminPage(props: Readonly<{ pageName: string }>) {
    //SnackBar
    const showMessage = useSnackbars();
    //Disable ou non le bouton de la validation
    const [page, setPage] = useState<PageAdminDto>();

    useEffect(() => {
        let isMounted = true;
        setPage(undefined);
        //Récupération de la apge
        getPageAdmin(props.pageName)
            .then(result => {
                isMounted && setPage(result);
            })
            .catch(error => {
                //Affichage du message d'erreur si la requete ne récupère rien
                showAxiosMessageError(error, showMessage);
            });
        //unamount
        return () => {
            isMounted = false;
        };
    }, [props.pageName, showMessage]);

    //Conditionnement de la vue
    return page ? <PageAdminUi page={page} /> : <Skeleton height={300} />;
}
